import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    toggleSidebarState: false,
    toggleSmallSidebarState: false,
    toggleProfileSidebarState: false,
    toggleMenuState: false,
    headingObj: {
        icon: false,
        title: ''
    }
}

const themeSlice = createSlice({
    name: "Theme Layout",
    initialState: initialState,
    reducers: {
        toggleSidebar: (state, actions) => {
            state.toggleSidebarState = actions.payload
        },
        toggleSmallSidebar: (state, actions) => {
            state.toggleSmallSidebarState = actions.payload
        },
        toggleProfileSidebar: (state, actions) => {
            state.toggleProfileSidebarState = actions.payload
        },
        toggleMenu: (state, actions) => {
            state.toggleMenuState = actions.payload
        },
        setHeading: (state, actions) => {
            state.headingObj = actions.payload
        }
    }
})


export const { toggleSidebar, toggleSmallSidebar, toggleProfileSidebar, toggleMenu, setHeading } = themeSlice.actions

export default themeSlice.reducer